import React from 'react';

import {BeneficiarySelection} from 'presentation/pages';

export const MakeBeneficiarySelection: React.FC = () => <BeneficiarySelection />;
